import React from "react";
import {useSelector, useDispatch} from "react-redux";
import {checkCopyPreAddData} from "../../../../store/actions/admission";

const CopyPreAddDataLink = ({admission, onHide}) => {
    const {copyPreviousDocuments_enable} = useSelector(state => state.auth.selectedHospital);
    const dispatch = useDispatch();

    // Only show the option if copyPreviousDocuments_enable is true
    if (!copyPreviousDocuments_enable) {
        return null;
    }

    const handleClick = () => {
        if (onHide) {
            onHide();
        }
        
        dispatch(checkCopyPreAddData(admission));
    };

    return (
        <a className="dropdown-item pointer" onClick={handleClick}>
            Copy pre-ad data from previous admission
        </a>
    );
};

export default CopyPreAddDataLink;